import TreatmentTypeSelector from './CustomActionComponents/TreatmentTypeSelector';
import CategoryTypeSelector from './CustomActionComponents/CategoryTypeSelector';

export const ACTION_CONDITION_KEYS = {
  HAVE_BIOMARKER: 'have_biomarker',
  HAS_IMMUNOTHERAPY_TRIALS: 'has_immunotherapy_trials',
  HAS_TREATMENT_HISTORY: 'has_treatment_history',
  SPONSORED_TRIAL_NCT_NUMBERS: 'sponsored_trial_nct_numbers',
  SPONSORED_TREATMENT_NCT_NUMBERS: 'sponsored_treatment_nct_numbers',
  SELECTED_STANDARD_ONLY: 'selected_standard_only',
  SELECTED_TRIAL: 'selected_trial',
  USER_HAVE_SPONSORED_TRIAL_LIST: 'userHaveSponseredTrialList',
  USER_HAS_SPONSORED_TREATMENTS: 'user_has_sponsored_treatments',
  TRIAL_WITHIN_100_MILES: 'trial_within_100_miles',
  HAS_LOCATION: 'has_location',
  HAS_TARGETED_TRIALS: 'has_targeted_trials',
  HAS_MISSING_CRITICAL_INFO: 'has_missing_critical_info',
  HAS_PHASE_3_TRIALS: 'has_phase_3_trials',
  URL_MATCH: 'urlMatch',
};

export const DISPLAY_CONTEXT = {
  ALL: 'all',
  NEW_USER: 'new_user',
  RETURNED_USER: 'returned_user',
};

export const DISPLAY_CONTEXTS = Object
  .values(DISPLAY_CONTEXT)
  .filter((value) => value !== DISPLAY_CONTEXT.ALL);

export const ACTION_IDENTIFIER_RENDER_COMPONENT = 'renderComponent';

export const ACTION_COMPONENTS = {
  TREATMENT_TYPE_SELECTOR: 'TreatmentTypeSelector',
  CATEGORY_TYPE_SELECTOR: 'CategoryTypeSelector',
};

export const ACTION_TRANSITION_DIRECTION = {
  LEFT: 'left',
  RIGHT: 'right',
};

export const componentMap = {
  [ACTION_COMPONENTS.TREATMENT_TYPE_SELECTOR]: TreatmentTypeSelector,
  [ACTION_COMPONENTS.CATEGORY_TYPE_SELECTOR]: CategoryTypeSelector,
};
